module.exports = __webpack_public_path__ + "static/gnss_hipersr_cutout_1-ceda1fc8a7cd3fb2ceeecc6fb1d34c9e.png";